// extracted by mini-css-extract-plugin
export default {"communicate-container":"communicate_communicate-container__yXc8p","header":"communicate_header__5Q0vS"};